import { AxiosConfig } from './axiosConfig';

/**
 * Preenche um html input do tipo select com os rastráveis associados ao cliente selecionado.
 *
 * É necessário ter dois select um com os clientes e outro vazio que receberá os rastreáveis do cliente selecionado.
 * O input select dos clientes deve ter a classe "cliente-selecionado" e o input select dos rastreáveis deve
 * ter o id "select2-popular-rastreaveis".
 *
 * Quando a página for recarregada, se o campo select com os clientes manter um valor selecionado, o campo select com
 * os rastreáveis sera repopulado. Adicone um input do tipo hidden, igual ao exemplo abaixo, para armazenar o
 * rastreável selecionado.
 *
 * <input type="hidden" id="rastreavel-selecionado" name="rastreavel_selecionado" value="{{ old('rastreavel_id') }}">
 *
 * Também pode ser adicionados alguns filtros que seram usados na consulta, adicione no input select o atributo
 * data-filtro="" e qual o filtro você deseja usar.
 *
 *  data-filtro="rastreadorIdNotNull=true"
 *  data-filtro="rastreadorIdNull=true"
 */
(function () {
    const select2ClienteSelecionado = $('.cliente-selecionado');
    const select2PopularRastreaveis = $('#select2-popular-rastreaveis');
    if (select2ClienteSelecionado.length === 0 || select2PopularRastreaveis.length === 0) {
        return;
    }

    const idClienteSelecionado = parseInt(select2ClienteSelecionado.val());
    if (Number.isInteger(idClienteSelecionado)) {
        _popularCampoSelect(idClienteSelecionado);
    }

    select2ClienteSelecionado.on('select2:select', function (evento) {
        const objetoResposta = evento.params.data;
        if (objetoResposta.id) {
            _popularCampoSelect(objetoResposta.id);
        }
    });

    /**
     * Popula o campo select com os rastreávies do cliente selecionado.
     *
     * @param {number} clienteId
     * @return {void}
     */
    function _popularCampoSelect (clienteId) {
        const axios = (new AxiosConfig()).instanciaAxios();

        axios.get(_montarUrlConsulta(clienteId))
        .then((response) => {
            let arrayModelos = [{id: '', text: 'Selecione um rastreável'}];
            if (Array.isArray(response.data) && response.data.length > 0) {
                response.data.forEach((rastreavel) => {
                    arrayModelos.push({id: rastreavel.id, text: rastreavel.identificacao});
                });
            }

            select2PopularRastreaveis.html(null);
            select2PopularRastreaveis.select2({
                data: arrayModelos,
            });

            const rastreavelSelecionado = parseInt($('#rastreavel-selecionado').val());
            if (Number.isInteger(rastreavelSelecionado)) {
                select2PopularRastreaveis.val(rastreavelSelecionado).trigger('change');
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

     /**
      * Url para consultar os rastreáveis.
      *
      * @param {number} clienteId
      * @return {string}
     */
     function _montarUrlConsulta (clienteId) {
        const urlSistema  = `${window.location.protocol}//${window.location.host}/rastreaveis/json`;
        const camposBusca = 'campos[rastreavel]=id,identificacao';
        let filtroBusca   = `clientesId[]=${clienteId}&status=1,3`;

         const maisFiltros = select2PopularRastreaveis.data('filtro');
         if (maisFiltros) {
             filtroBusca += `&${maisFiltros}`;
         }

        return `${urlSistema}?${camposBusca}&${filtroBusca}`;
    }
})();
